<template>
<div class="layout-page">
    <div id="header">
        <slot name="header">
            <div class="sample-content">
                <template v-for="n in 50">Header </template>
            </div>
        </slot>
    </div>
    <div class="layout-content" :style="contentStyle">
        <div  v-for="(column, index) in columnList"  :id="'col' + (index + 1)" class="layout-column" :style="{'flex-basis': column.width}" :key="index">
            <div class="layout-column-padder">
                <slot :name="'col' + (index + 1)">
                    <div class="sample-content">
                        <template v-for="n in 400">Column {{index}} </template>
                    </div>
                </slot>
            </div>
        </div>
    </div>
    <div id="footer" >
        <slot name="footer">
            <div style="height:15px"></div>
        </slot>
    </div>
    <div id="dialogs" >
        <slot name="dialogs">
      
        </slot>
    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import Store from '../store/Store'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        columns: {
            default: '50/50',
            type: String
        },
        width: {
            default: 1280,
            type: Number
        }
    },

    computed: {
        columnList() {
            let columnList = this.columns.split(/\//).map(width => {
                let w = width

                if(window.innerWidth < 600)
                    w='100%'

                if(w.indexOf('px') < 0 )
                    w=w+'%'

                return {
                    width: w
                }
            })
            return columnList
        },
        contentStyle() {
            return {
                'max-width': this.width + 'px'
            }
        },
        isMichelle() {
            let user = Store.getters.user
            return user.firstName == 'Michelle' && user.lastName == 'Solomon'
        }
    },

    methods: {
        scrollLeftColumn(position) {

        }
   
    },

    created() {

    }
}
</script>

<style scoped>

@media (min-width: 600px) {

    .layout-page {
        height:100%;
        display:flex;
        flex-direction:column;
        overflow:auto;
        background-color:#eee;
    }

    .layout-content {
        height:0;  
        /* why is this needed now for scrolling */
        flex:1;
        display:flex;
        margin:auto;
        background-color:#f9f9f9;
        width:100%
    }

    .layout-column {
        overflow-y:auto;
        overflow-x:hidden;
        flex:1;
        -webkit-overflow-scrolling: touch;
    }

}

.layout-column-padder {
    padding:5px 10px 10px 5px;
}

.sample-content {
    background-color:#ddd;
    border: dotted 3px #bbb;
    margin:1px;
    color: #bbb
}
   
</style>




// WEBPACK FOOTER //
// LayoutContainer.vue?be06f33e